exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".roles__container[data-v-79be214b]{display:flex;justify-content:flex-start;margin:0 0 10px 0;flex-direction:row;flex-wrap:wrap;gap:20px;padding-left:25px}.roles__div[data-v-79be214b]{position:absolute;margin-top:13px}\n", ""]);

